import React, { useState, useEffect, useRef } from "react";
import Modal from "react-modal";
import "../styles/Modal.css";

const DriverDetailsModal = ({ isOpen, onRequestClose, driver }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const modalBodyRef = useRef(null);

  useEffect(() => {
    return () => {
      clearTimeout(window.successMessageTimeout);
    };
  }, []);

  useEffect(() => {
    if (!isOpen || !driver) {
      return;
    }
    setError(null);
    setSuccessMessage(null);
  }, [isOpen, driver]);

  if (!isOpen || !driver) {
    return null;
  }

  const modalContent = (
    <div className="modal-content">
      <div className="modal-header">
        <h5>Driver Details: {driver.name || "Unknown Driver"}</h5>
        <div className="header-buttons">
          <button className="close-button" onClick={onRequestClose}>×</button>
        </div>
      </div>
      <div className="modal-body" ref={modalBodyRef}>
        {loading && <div className="modal-loading">Loading...</div>}
        {error && <div className="modal-error">{error}</div>}
        {successMessage && <div className="modal-success">{successMessage}</div>}
        
        <div className="modal-info">
          <i className="fas fa-user"></i>
          <span><strong>Name:</strong> {driver.name || "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-id-card"></i>
          <span><strong>UUID:</strong> {driver.uuid || "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-phone"></i>
          <span><strong>Phone:</strong> {driver.telephone || "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-circle" style={{ color: driver.status === "FREE" ? "#00FF00" : driver.status === "BUSY" ? "#1E90FF" : "#FF0000" }}></i>
          <span><strong>Status:</strong> {driver.status || "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-tag"></i>
          <span><strong>Type:</strong> {driver.type || "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-box"></i>
          <span><strong>Orders:</strong> {driver.nb_commande || 0}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-battery-three-quarters" style={{ color: driver.battery && parseInt(driver.battery) <= 20 ? "#FF0000" : "#00FF00" }}></i>
          <span><strong>Battery:</strong> {driver.battery || "N/A"}%</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-map-marker-alt"></i>
          <span><strong>Location:</strong> {driver.lat && driver.lng ? `${driver.lat}, ${driver.lng}` : "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-clock"></i>
          <span><strong>Last Update:</strong> {driver.last_update ? `${driver.last_update} min ago` : "N/A"}</span>
        </div>
        
        <div className="modal-info">
          <i className="fas fa-plug" style={{ color: driver.connected == 1 ? "#00FF00" : "#FF0000" }}></i>
          <span><strong>Connected:</strong> {driver.connected == 1 ? "Yes" : "No"}</span>
        </div>
        
        {driver.solde_livreur && (
          <div className="modal-info">
            <i className="fas fa-wallet"></i>
            <span><strong>Balance:</strong> {driver.solde_livreur} MAD</span>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="modal"
      overlayClassName="modal-overlay"
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      parentSelector={() => document.getElementById("modal-root") || document.body}
    >
      {modalContent}
    </Modal>
  );
};

export default DriverDetailsModal;
